import { render } from "./confirmDeleteModal.vue?vue&type=template&id=e2691366&scoped=true&ts=true"
import script from "./confirmDeleteModal.vue?vue&type=script&lang=ts"
export * from "./confirmDeleteModal.vue?vue&type=script&lang=ts"

import "./confirmDeleteModal.vue?vue&type=style&index=0&id=e2691366&scoped=true&lang=css"

import exportComponent from "/builds/psj7085139/sam/samva-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2691366"]])

export default __exports__